import styled from 'styled-components';

const Container = styled.main `
  display: flex;
  flex-direction: column;

  margin: 0 auto;

  max-width: 1280px;
  width: 100%;
`;

export { Container };
